<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GhXz23/tc-custom/9781250113436.jpg?1720831243279" alt="This image is the cover for the book Merry Spinster"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Merry Spinster
      </h1>
      <p class="bookDescription body article font2">
        <b>“Empowering, subversive. . . . Lavery twists fairy tales into elegant garrotes . . . There’s not a single weak link in the cat’s-breath chain of this collection.” —The New York Times Book Review</b><br/><br/>Adapted from the beloved “Children’s Stories Made Horrific” series, <i>The Merry Spinster</i> takes up the trademark wit that endeared Daniel M. Lavery to readers of both <i>The Toast</i> and the bestselling <i>Texts from Jane Eyre</i>. Sinister and inviting, familiar and alien all at the same time, <i>The Merry Spinster</i> twists traditional children’s stories and fairy tales with elements of psychological horror, emotional clarity, and a keen sense of feminist mischief.<br/><br/>Unfalteringly faithful to its beloved source material<i>, The Merry Spinster</i> also illuminates the unsuspected and frequently alarming emotional complexities at play in the stories we tell ourselves, and each other, as we tuck ourselves in for the night.<br/><br/>“A wholly satisfying blend of silliness, feminist critique, and deft prose makes this a collection of bedtime stories that will keep you up at night for all the right reasons.” —<i>Kirkus Reviews</i>, starred review<br/><br/>“Lavery’s sly, scathing renditions . . . strike directly at the heart. . . . The book brings the shock of the new and the shock of recognition into play at the same time; it’s a tour de force of skill, daring, and hard-earned bravura.” —<i>Publishers Weekly</i> (starred review)<br/><br/>“Dark and dreadful and persistently clever. Lavery bloodily turns familiar tales inside out.” —Rainbow Rowell, #1 <i>New York Times</i>–bestselling author of <i>Carry On</i><br/><br/>“Subversive fun.” —Ms Magazine<br/><br/>“Twisted tales that will shock and delight you.” —Esquire<br/><br/>“Feminist fairy tales? Just what the doctor ordered.” —ELLE<br/><br/>“Primordial, oppressive, and funny.” —Boris Kachka, New York Magazine
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel M. Lavery
      </h2>
      
      <p class="authorDescription body article"><B>Daniel M. Lavery</B> is the co-creator of The Toast and the author of the <I>New York Times </I>Bestseller <I>Texts From Jane Eyre</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d529dd80